import { Component, OnInit } from "@angular/core";
import * as _ from "lodash";
import moment from "moment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { TalentPayrollService } from "../../../shared/services/talent-payroll.service";
import { NbcBudgetCodeComponent } from "../../../shared/component/nbc-budget-code/nbc-budget-code.component";

@Component({
    selector: "modal-multi-timecards",
    templateUrl: "./modal-multiple-timecards.component.html",
    standalone: false
})
export class ModalMultipleTimecardsComponent implements OnInit {
    constructor(
        public bsModalRef: BsModalRef,
        public _modalService: BsModalService,
        private talentService: TalentPayrollService,
        private log: NbcLoggerService
    ) {}

    public onSync!: Subject<any>;

  /*shared from parent application*/
  batchId: any;
  buAccess: any;
  networks: any = [];
  workStates: any= [];
  employeeTypes: any= [];
  sports: any = [];
  daytypes: any = [];
  
  companyCodes: any = [];
  contactsSelectedForUpdate: any = [];
  /*uptil here*/

    costCenterType: any = "wbse";
    showwbse = true;
    showcc = false;
    timecard: any = {};
    selectedDates: any = [];
    displaySelectedDates: any = "";

    wbseorcc() {
        if (this.costCenterType === "wbse") {
            this.showwbse = true;
            this.showcc = false;
        } else {
            this.showwbse = false;
            this.showcc = true;
        }
    }

    createTimeSheet() {
        const timecards = [];
        if (!_.isEmpty(this.contactsSelectedForUpdate)) {
            _.forEach(this.contactsSelectedForUpdate, (contact) => {
                _.forEach(this.selectedDates, (tcDate) => {
                    const timecard: any = this.getTimecard(tcDate);
                    timecard.contact = contact;
                    timecards.push(timecard);
                });
            });
        } else {
            _.forEach(this.selectedDates, (tcDate) => {
                const timecard = this.getTimecard(tcDate);
                timecards.push(timecard);
            });
        }

        this.talentService
            .upsertTimecards(this.buAccess.businessUnitId, timecards)
            .subscribe({
                next: (result) => {
                    //this.onSync.next(),
                    this.onSync.next(""); //TODO: Revisit
                },
                error: (err) =>
                    this.log.error("multiple timecards: received error " + err),
            });
        this.bsModalRef.hide();
    }

    customFormat(rate) {
      if (rate) {
        this.timecard.customRate = this.formatNumber(rate);
      }
    }

    formatNumber(value: number | string): string {
      // Handle empty, null, or undefined input
      if (value === null || value === undefined || value === '') {
        return '';
      }

      // Convert the input to a number
      let numericValue: number;
      if (typeof value === 'string') {
        numericValue = parseFloat(value.replace(/,/g, '')); // Remove commas if present
      } else {
        numericValue = value;
      }

      // Validate if the input is a valid number
      if (isNaN(numericValue)) {
        throw new Error('Invalid input: value is not a valid number.');
      }

      // Format the number with commas and two decimal places
      return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }


    openWBSEModal() {
        let modalBudgetCodeRef: BsModalRef;

        const initialState: any = {
            self: this,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalBudgetCodeRef = this._modalService.show(
            NbcBudgetCodeComponent,
            modalOptions
        );
        modalBudgetCodeRef.content.onSync.subscribe((wbse) => {
            if (wbse && wbse.code) {
                this.timecard.wbsecode = wbse.code;
                this.timecard.wbseDescription = wbse.description;

                if (wbse.coCode) {
                    const coLookupObj = {
                        id: wbse.coCode,
                        name: "",
                        description: wbse.coCode,
                    };
                    this.timecard.companyCode = coLookupObj;
                }
            }
        });
    }
    cancel() {
        this.log.trace("cancel");
        this.bsModalRef.hide();
    }

  getTimecard (tcDate) {
    var timecard = {
      "id": -1,
      "activityDate": moment(tcDate.date).format("MM-DD-YYYY"),
      "createdByDepartment": {
        "id": this.buAccess.departmentId
      },
      "timeSheetBatch": {
        "id": this.batchId
      },
      "eventShowName": this.timecard.eventShowName,
      "glAccount": this.timecard.glAccount,
      "companyCode": this.timecard.companyCode?.description,
      "customRate": this.timecard.customRate,
      "sport":
      {
        id: this.timecard.sport?.id
      },
      "daytype":
      {
        id: this.timecard.daytype?.id
      },
      "network": {
        id: this.timecard.network?.id
      },
      "employeeType": {
        id: this.timecard.employeeType?.id
      },
      "stateContactWorked": {
        id: this.timecard.stateContactWorked?.id
      },
      "wbse": this.timecard.wbsecode,
      "wbseDescription": this.timecard.wbseDescription,
      "costCenter": this.timecard.costCenter,
      hoursWorked: this.timecard.hoursWorked
    };
    return timecard;
  }

    datesValueChanged(selectedDates) {
        this.selectedDates = selectedDates;
        const dates = _.map(selectedDates, "displayDate");
        this.displaySelectedDates = dates.join(",");
    }

    ngOnInit() {
        this.onSync = new Subject();
    }
}
